export interface YourProductApplication {
    chkAgree: boolean;
    chkSign: boolean;
    updatesVia: {
        email: boolean;
        post: boolean;
        text: boolean;
        telephone: boolean;
        pom: boolean;
    };
}
